module["exports"] = [
  "Dhr.",
  "Mevr. Dr.",
  "Bsc",
  "Msc",
  "Prof."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/name/prefix.js
// module id = 1542
// module chunks = 0